import { render, staticRenderFns } from "./AssessmentTable.vue?vue&type=template&id=20a0f309&scoped=true"
import script from "./AssessmentTable.vue?vue&type=script&lang=js"
export * from "./AssessmentTable.vue?vue&type=script&lang=js"
import style0 from "./AssessmentTable.vue?vue&type=style&index=0&id=20a0f309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a0f309",
  null
  
)

export default component.exports